import { __decorate } from "tslib";
import { LitElement, html, customElement, internalProperty } from 'lit-element';
import { getData } from './utils';
let DemoDetailView = class DemoDetailView extends LitElement {
    constructor() {
        super(...arguments);
        this.data = getData();
        this.currentDetail = null;
    }
    render() {
        var _a, _b, _c, _d, _e;
        return html `
      <cds-grid>
        <cds-grid-column width="44"></cds-grid-column>
        <cds-grid-column>Stock</cds-grid-column>
        <cds-grid-column>Average</cds-grid-column>
        <cds-grid-column>Current</cds-grid-column>
        <cds-grid-column>About</cds-grid-column>
        ${this.data.map(entry => html `
          <cds-grid-row>
            <cds-grid-cell>
              <cds-inline-button id="${entry.id}-detail-demo" aria-label="view ${entry.id} details" @click=${() => this.showDetail(entry.id)} style="margin-right: 8px">
                <cds-icon shape="angle" direction="right"></cds-icon>
              </cds-inline-button>
            </cds-grid-cell>
            <cds-grid-cell>${entry.id}</cds-grid-cell>
            <cds-grid-cell>$${entry.average}</cds-grid-cell>
            <cds-grid-cell>$${entry.value}</cds-grid-cell>
            <cds-grid-cell>${entry.about}</cds-grid-cell>
          </cds-grid-row>
        `)}
        <cds-grid-footer></cds-grid-footer>
        <cds-grid-detail ?hidden=${!this.currentDetail} anchor="${(_a = this.currentDetail) === null || _a === void 0 ? void 0 : _a.id}-detail-demo" @closeChange=${this.closeDetail}>
          <h2>${(_b = this.currentDetail) === null || _b === void 0 ? void 0 : _b.id}</h2>
          <p>Average: $${(_c = this.currentDetail) === null || _c === void 0 ? void 0 : _c.average}</p>
          <p>Current: $${(_d = this.currentDetail) === null || _d === void 0 ? void 0 : _d.value}</p>
          <p>About: ${(_e = this.currentDetail) === null || _e === void 0 ? void 0 : _e.about}</p>
        </cds-grid-detail>
      </cds-grid>
    `;
    }
    showDetail(id) {
        this.currentDetail = this.data.find(i => i.id === id);
    }
    closeDetail() {
        this.currentDetail = null;
    }
    createRenderRoot() {
        return this;
    }
};
__decorate([
    internalProperty()
], DemoDetailView.prototype, "data", void 0);
__decorate([
    internalProperty()
], DemoDetailView.prototype, "currentDetail", void 0);
DemoDetailView = __decorate([
    customElement('demo-detail-view')
], DemoDetailView);
export { DemoDetailView };
//# sourceMappingURL=demo.detail-view.js.map